import { render, staticRenderFns } from "./LocalLogin.vue?vue&type=template&id=76b63850"
import script from "./LocalLogin.vue?vue&type=script&lang=ts"
export * from "./LocalLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b63850')) {
      api.createRecord('76b63850', component.options)
    } else {
      api.reload('76b63850', component.options)
    }
    module.hot.accept("./LocalLogin.vue?vue&type=template&id=76b63850", function () {
      api.rerender('76b63850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/login/LocalLogin.vue"
export default component.exports